import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pending-evaluation',
  templateUrl: './pending-evaluation.component.html',
  styleUrls: ['./pending-evaluation.component.css']
})
export class PendingEvaluationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
